import { actionTypes } from "../actionTypes/actionTypes";
import { IUserDetailsPermissionState } from "../../interfaces/store/IUserDetailsPermissionState";
import { COMMON } from "../../constants/common";

const initialState: IUserDetailsPermissionState = {
  userDetails: (() => {
    const stored = localStorage.getItem(COMMON.USER_DETAILS_LS_KEY.DETAILS);
    return stored ? JSON.parse(stored) : null;
  })(),
  rolePermission: (() => {
    const stored = localStorage.getItem(
      COMMON.USER_DETAILS_LS_KEY.ROLE_PERMISSION
    );
    return stored ? JSON.parse(stored) : null;
  })(),
};

const userDetailsPermissionReducer = (
  state: IUserDetailsPermissionState = initialState,
  action: any
) => {
  switch (action.type) {
    case actionTypes.UPDATE_USER_DETAILS:
      return {
        ...state,
        userDetails: action.payload,
      };
    case actionTypes.UPDATE_USER_PERMISSION:
      return {
        ...state,
        rolePermission: action.payload,
      };

    default:
      return state;
  }
};

export default userDetailsPermissionReducer;
